import { ApiRestService } from '../../Progetti/_services/api-rest.service';
import { ProdottiStoreService } from '../../Progetti/_services/prodotti-store.service';
import { Categorie } from '../../Progetti/Models/Categorie';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ActivatedRoute, Router } from '@angular/router';
import {Permission} from "../../Login/_guards/Permission";
import {ToastrService} from "ngx-toastr";
import {ApiPathsService} from "../../api-paths.service";
import {environment} from "../../../environments/environment";
import {TranslateObj} from "../../shared/models/translatedesc";

@Component({
  selector: 'app-categorie',
  templateUrl: './categorie.component.html',
  styleUrls: ['./categorie.component.scss']
})
export class CategorieComponent implements OnInit{
  Env = environment;
  categoriedropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'categoria',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  sel_cat_id: number = 0;
  type;
  standby: boolean = false;
  CategoriaDaModificare: Categorie = null;
  LabelCategoria: string = "";
  showMenu = '';
  showSubMenu = '';
  modificheAbilitate: boolean = false;
  CategorieLineare: Categorie[] = [];
  CategorieSelezionate: Categorie[] = [];
  public sidebarnavItems: Categorie[] = []
  path = '';
  @Input() showClass: boolean = false;
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();
  transaltedobjects: TranslateObj[];
  Ordine: number;

  handleNotify() {
    this.notify.emit(!this.showClass);
  }

  constructor(private progettiStore: ProdottiStoreService, public apiPaths: ApiPathsService, private toastService: ToastrService, private modalService: NgbModal, private apirest: ApiRestService, public router: Router, private route: ActivatedRoute, public permission: Permission) {
    this.progettiStore.getCategorieProdotti();
    this.progettiStore.$categorieProdotti.subscribe(data => this.sidebarnavItems = data);
    this.progettiStore.$categorieProdottiLineare.subscribe(data => {
      if (data !== null)
        this.CategorieLineare = data;
    });
  }
  ngOnInit() {
    this.route.params.subscribe(data => {
      this.type = data['type'];
      console.log(this.type)
      if (!isNaN(parseInt(this.type)))
        this.sel_cat_id = parseInt(this.type);
    })
  }

  AbilitaModifiche(){
    this.modificheAbilitate =  !this.modificheAbilitate;
  }
  Elimina(value: Categorie){
    if(confirm("Sei sicuro di voler eliminare questa categoria?"))
      this.apirest.deleteCategoria(value).subscribe(data => {
        this.progettiStore.getCategorieProdotti();
      })
  }

  filtroCategoria(item: string) {
    this.progettiStore.getCategorieListanofigli(new RicercaPaginazione(item, undefined, undefined));
  }
  clicked(cat:Categorie){
    var urlToOpen: string = cat&&!isNaN(cat.id) ? `progetti/prodotti/lista/${cat.id.toString()}` : `progetti/prodotti/lista`;
    this.sel_cat_id = cat&&!isNaN(cat.id) ? cat.id : 0;
    this.router.navigate([this.route.snapshot.queryParams[urlToOpen] || urlToOpen,]);
  }

  openModal(targetModal: NgbModal, selected: Categorie, selectedParent: Categorie) {
    this.modalService.open(targetModal, { centered: true, backdrop: 'static'});
    this.CategoriaDaModificare = selected ?? new Categorie();
    this.CategorieSelezionate = selectedParent ? [selectedParent] : [];
    this.LabelCategoria = selected ? selected.categoria : "";
    this.Ordine = selected ? selected.ordine : 0;
    this.transaltedobjects = selected ? this.gettransaltedobjects(selected): this.createlang(["en", "es", "fr", "de"]);
  }

  createlang(values: string[]): TranslateObj [] {
    var output: TranslateObj [] = [];
    output.push({
      default: true,
      lang: "it",
      TranslateInputs: [ {id: "categoria", label:"Nome Categoria", value: "", type: "text"}, {id: "slug" , label:"SEO Slug Italiano", value: "", type: "text"}]
    })
    values?.forEach(value=>{
      output.push({
        default: false,
        lang: value,
        TranslateInputs: [
          {id: "categoria", label:"Nome Categoria", value: "", type: "text"},
          {id: "slug" , label:"SEO Slug ", value: "", type: "text"}
        ]
      })
    })
    return output;
  }

  gettransaltedobjects(item: Categorie): TranslateObj[]{
    return [{
        default: true,
        lang: "it",
        TranslateInputs: [ {id: "categoria", label:"Nome Categoria", value: item?.categoria, type: "text"}, {id: "slug" , label:"SEO Slug Italiano", value: item?.slug, type: "text"}]
      }
    ].concat(item.traduzioni);
  }

  updateFields(translateObjects: TranslateObj[]){
    this.CategoriaDaModificare.traduzioni = translateObjects?.filter(x => !x.default)
  }
  saveModalButton() {
    if (this.CategoriaDaModificare !== null ) {
      const updateData = this.CategoriaDaModificare;
      updateData.standby = this.standby;
      updateData.categoria = this.Env.ProdottiAddOn.TranslatedDesc? this.transaltedobjects?.find(x => x.default)?.TranslateInputs?.find(x => x.id == "categoria")?.value : this.LabelCategoria;
      updateData.slug = this.transaltedobjects?.find(x => x.default)?.TranslateInputs?.find(x => x.id == "slug")?.value;
      updateData.cat_id = this.CategorieSelezionate != null && this.CategorieSelezionate.length > 0? this.CategorieSelezionate[0].id: undefined;
      updateData.traduzioni = this.transaltedobjects?.filter(x => !x?.default)
      updateData.ordine = this.Ordine;
      if (this.CategoriaDaModificare.id)
        this.apirest.updateCategoria(updateData).subscribe(() => this.modalClose());
      else
        this.apirest.addCategoria(updateData).subscribe(() => this.modalClose());
    }
  }
  deleteModalButton() {
    const updateData = new Categorie();
    updateData.id = this.CategoriaDaModificare.id;
    updateData.cat_id = this.CategorieSelezionate?.length > 0 ? this.CategorieSelezionate[0].id : undefined;
    this.apirest.deleteCategoria(updateData).subscribe(() => this.modalClose());
  }
  modalClose(){
    this.progettiStore.getCategorieProdotti();
    this.closeBtnClick()
  }

  closeBtnClick() {
    this.modalService.dismissAll();
  }
  async immaginecambiata(event) {
    const file: Blob = event.target.files[0];
    if (!file.type.includes("image")){
      this.toastService.warning("Questo formato non è supportato. Inserire solo immagini.", "Attenzione!")
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.CategoriaDaModificare.immagine = reader?.result?.toString()?.length > 1 ? reader.result.toString(): undefined;
      this.CategoriaDaModificare.file = reader?.result?.toString()?.length > 1 ? event.target.files[0].name: this.CategoriaDaModificare.file;
    };
  }

  Iconacambiata(event) {
    const file: Blob = event.target.files[0];
    if (!file.type.includes("image")){
      this.toastService.warning("Questo formato non è supportato. Inserire solo immagini.", "Attenzione!")
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.CategoriaDaModificare.icona = reader?.result?.toString()?.length > 1 ? reader.result.toString(): undefined;
      this.CategoriaDaModificare.fileIcona = reader?.result?.toString()?.length > 1 ? event.target.files[0].name: this.CategoriaDaModificare.fileIcona;
    };
  }
}
